module.exports = __webpack_public_path__ + "static/media/BM7100-59H_03.5c75c246.png";